import script from "./CalendarioAgendamentoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioAgendamentoComponent.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioAgendamentoComponent.vue?vue&type=style&index=0&id=bdacd878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdacd878"]])

export default __exports__